@if ({
  product: product$ | async,
  mainContent: mainContent$ | async,
  }; as content) {
  @if (content.product) {
    <div class="container-simple-gallery">
      <div class="main-image type-{{ content.mainContent?.type }}">
        @if (content.mainContent?.type === GALLERY_MEDIA_TYPE.VIDEO) {
          <iframe-viewer [iframe]="getIframeVideo(content.mainContent?.content!)"></iframe-viewer>
        }
        @if (content.mainContent?.type === GALLERY_MEDIA_TYPE.IMAGES) {
          @if (content?.mainContent?.content?.superZoom?.url || content?.mainContent?.content?.zoom?.url) {
            <div class="main-image type-{{ content.mainContent?.type }}" style="position: relative;">
              <img [src]="content?.mainContent?.content?.superZoom?.url || content?.mainContent?.content?.zoom?.url" alt=""
                (click)="openModal(content.mainContent)" (keyup.enter)="openModal(content.mainContent)" [attr.tabindex]="0"
                class="zoom-in" />
                @if (content.product?.representativeImage?.toLowerCase() === 'yes') {
                  <div class="image-overlay">
                    {{ 'productDetails.representativeImage' | cxTranslate }}
                  </div>
                }
              </div>
            } @else {
              <cx-media [container]="" tabindex="0" [format]="'superZoom'"></cx-media>
            }
          }
          @if (content.mainContent?.type === GALLERY_MEDIA_TYPE.IMAGE_360) {
            <magic-360 [image360]="content.mainContent?.content!"></magic-360>
          }
        </div>
        <div class="simple-thumbs">
          <simple-thumbs></simple-thumbs>
        </div>
      </div>
    }
  }
